import { render } from "./editIdentity.vue?vue&type=template&id=529ca560&scoped=true"
import script from "./editIdentity.vue?vue&type=script&lang=js"
export * from "./editIdentity.vue?vue&type=script&lang=js"

import "./editIdentity.vue?vue&type=style&index=0&id=529ca560&lang=scss"
import "./editIdentity.vue?vue&type=style&index=1&id=529ca560&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529ca560"],['__file',"src/views/exhibitionManage/components/editIdentity.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "529ca560"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('529ca560', __exports__)) {
    console.log('reload')
    api.reload('529ca560', __exports__)
  }
  
  module.hot.accept("./editIdentity.vue?vue&type=template&id=529ca560&scoped=true", () => {
    console.log('re-render')
    api.rerender('529ca560', render)
  })

}


export default __exports__